import { Link } from '@tanstack/react-router';
import type { RecordReference } from '../../lib/api-types';
import styles from './Crm.module.css';

export function RelatedRecords({ references, objectFilter, onObjectFilter, search, onSearch }: {
  references: RecordReference[];
  objectFilter: string;
  onObjectFilter: (value: string) => void;
  search: string;
  onSearch: (value: string) => void;
}) {
  const records = [...new Map(references.map((reference) => [
    `${reference.objectMetadataId}:${reference.id}`, reference,
  ])).values()].sort((a, b) => a.label.localeCompare(b.label));
  const types = [...new Map(records.map((record) => [record.objectMetadataId, record.objectLabelSingular])).entries()]
    .sort((a, b) => a[1].localeCompare(b[1]));
  const query = search.trim().toLocaleLowerCase();
  const filtered = records.filter((record) => (!objectFilter || record.objectMetadataId === objectFilter)
    && (record.label || 'Untitled').toLocaleLowerCase().includes(query));

  return <>
    <div className={styles.relatedFilters}>
      <select aria-label="Filter related records by object type" value={objectFilter}
        onChange={(event) => onObjectFilter(event.target.value)}>
        <option value="">All object types</option>
        {types.map(([id, label]) => <option key={id} value={id}>{label}</option>)}
      </select>
      <input type="search" aria-label="Search related records" placeholder="Search related records…"
        value={search} onChange={(event) => onSearch(event.target.value)} />
    </div>
    <p className={styles.relatedCount} role="status">{filtered.length} of {records.length} related records</p>
    {records.length === 0 ? <p className={styles.state}>No linked records yet.</p>
      : filtered.length === 0 ? <p className={styles.state}>No related records match these filters.</p>
      : <ul className={styles.relatedList}>
        {filtered.map((record) => <li key={`${record.objectMetadataId}:${record.id}`}>
          <Link to="/app/o/$object/$recordId" params={{ object: record.objectNamePlural, recordId: record.id }}
            className={styles.relatedLink}>
            <span className={styles.relatedName}>{record.label || 'Untitled'}</span>
            <span className={styles.cardMeta}>{record.objectLabelSingular}</span>
          </Link>
        </li>)}
      </ul>}
  </>;
}

